var render = function render(){var _vm=this,_c=_vm._self._c;return _c('store-count-table',{attrs:{"product-type":"产品"}})
}
var staticRenderFns = []

export { render, staticRenderFns }